import { queryOne } from '../core/dom.js';

export function renderConnectionStatus(mode, statusState, {
  indicatorEl,
  statusTextEl,
  reconnectBtn = queryOne('#reconnectBtn')
}) {
  if (!indicatorEl || !statusTextEl) return;

  if (mode !== 'online') {
    indicatorEl.classList.add('hidden');
    return;
  }

  indicatorEl.classList.remove('hidden');
  indicatorEl.classList.remove('connecting', 'reconnecting', 'disconnected', 'connected');

  if (statusState === 'connected') {
    indicatorEl.classList.add('connected');
    statusTextEl.textContent = 'Trực tuyến';
    reconnectBtn?.classList.add('hidden');
    return;
  }

  if (statusState === 'connecting' || statusState === 'reconnecting') {
    indicatorEl.classList.add(statusState);
    statusTextEl.textContent = statusState === 'connecting' ? 'Đang kết nối...' : 'Kết nối lại...';
    reconnectBtn?.classList.add('hidden');
    return;
  }

  indicatorEl.classList.add('disconnected');
  statusTextEl.textContent = 'Mất kết nối';
  reconnectBtn?.classList.remove('hidden');
}

export function deriveOnlineGameStatus({ state, userSide, pendingRequestId, sideName }) {
  let text = `Lượt ${sideName(state.sideToMove)}`;
  let subtext = 'Đang trong ván đấu';

  if (state.status === 'waiting') {
    text = 'Đang chờ đối thủ vào phòng...';
    subtext = 'Vui lòng mở link trên thiết bị thứ 2 và chọn bên còn lại.';
  } else if (state.status === 'finished') {
    text = state.result?.reason || 'Ván đấu kết thúc';
    subtext = 'Bấm "Yêu cầu chơi lại" để bắt đầu ván mới.';
  } else if (state.status === 'abandoned') {
    text = state.result?.reason || 'Đối thủ đã rời hoặc mất kết nối';
    subtext = 'Phòng sẵn sàng nhận người chơi cho bên còn trống.';
  } else if (userSide) {
    subtext = state.sideToMove === userSide
      ? '👉 Đến lượt của bạn!'
      : 'Đang chờ đối thủ đi nước...';
  } else {
    subtext = 'Chế độ người xem (Spectator)';
  }

  if (state.check && state.status === 'active') text += ' (Đang bị chiếu!)';
  if (pendingRequestId) subtext = 'Đang xác nhận nước đi với máy chủ...';

  return { text, subtext };
}
